import React from "react";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";

import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";

function AddButton() {
  const { t } = useTranslation();
  return (
    <div>
      <Button
        component={Link}
        to={{
          pathname: "/editor",
          state: {
            from: "library",
            interactionId: -1,
            mode: "create",
            type: "public",
          },
        }}
        variant="outlined"
        startIcon={<AddIcon />}
      >
        {t("create.newSurvey")}
      </Button>
    </div>
  );
}

export default AddButton;
